import './Text.css';

function SafetyStandards() {
  return (
    <div className="Container">
      <header className="Container-header">
        <h1>Policy on Child Sexual Abuse and Exploitation (CSAE)</h1>
        <p><strong>Last updated:</strong> July 20, 2025</p>

        <p>
          This Policy outlines our zero-tolerance stance on any form of child sexual abuse, exploitation, or grooming activity. We are committed to protecting children and upholding the highest standards of safety, compliance, and legal accountability.
        </p>

        <h2>Zero Tolerance Statement</h2>
        <p>
          We strictly prohibit using our services for CSAM, grooming, exploitation, or any harm to minors. Violations are reported to authorities and result in permanent bans.
        </p>

        <h2>Definitions</h2>
        <ul>
          <li><strong>Child:</strong> Any person under the age of 18.</li>
          <li><strong>CSAM:</strong> Content that depicts, promotes, or solicits abuse/exploitation of a child.</li>
          <li><strong>Exploitation:</strong> Illegal/harmful use of a child for the benefit of others.</li>
          <li><strong>Grooming:</strong> Actions to befriend and gain trust with a child for abuse.</li>
        </ul>

        <h2>Our Commitments</h2>
        <ul>
          <li>Detect, prevent, and report CSAE incidents.</li>
          <li>Cooperate with law enforcement and report all CSAM.</li>
          <li>Use monitoring tools and allow user reporting.</li>
          <li>Remove and ban users without warning or appeal.</li>
          <li>Comply with international/local child protection laws.</li>
        </ul>

        <h2>Reporting Abuse</h2>
        <p>
          Report suspected CSAE immediately to <strong>app.hang10@gmail.com</strong> or your local authorities. You can also report via the <a href="https://report.cybertip.org/" target="_blank" rel="noopener noreferrer">CyberTipline</a> (U.S.).
        </p>

        <h2>Enforcement</h2>
        <p>
          Violations will result in immediate suspension, content removal, and law enforcement cooperation.
        </p>

        <h2>Policy Updates</h2>
        <p>
          This policy may be updated. Changes will be posted with a new "Last updated" date.
        </p>

        <h2>Contact Us</h2>
        <p>Email: <a href="mailto:app.hang10@gmail.com">app.hang10@gmail.com</a></p>
      </header>
    </div>
  );
}

export default SafetyStandards;
